const enableReschedule = (state = null, action) => {
    if (action.type === "SET_ENABLE_RESCHEDULE") {
        return action.payload;
    } else {
        return state;
    }
};

export default enableReschedule;
